import { observer } from 'mobx-react-lite';
import { CheckboxField } from '../../../../../components';
import Product from '../../../store/Product';

export default observer(function SettingsWidget({
  product,
}: {
  product: Product;
}) {
  return (
    <CheckboxField
      helperText="When a customer orders on your store, Pulse will generate a random key to be emailed to the customer after purchase"
      label="Generate keys automatically"
      name="generateKeysAutomatically"
      onChange={product.handleChange}
      sx={{ mt: 0 }}
      value={product.generateKeysAutomatically}
    />
  );
});
